import { Reducer } from 'react';
import { negate } from 'lodash/fp';
import { LicenseAction } from '../../../../../types/__generated__/graphql';

export interface LicenseUpdate {
  productFamilyId: number;
  productCurriculumId: number;
  studentId: number;
  action: LicenseAction;
}

export enum ActionType {
  ADD_UPDATE = 'ADD_UPDATE'
}

interface AddUpdateAction {
  type: ActionType.ADD_UPDATE;
  payload: LicenseUpdate;
}

type Action = AddUpdateAction;

const isSameStudentCurriculum = (first: LicenseUpdate) => (second: LicenseUpdate) =>
  first.studentId === second.studentId &&
  first.productFamilyId === second.productFamilyId &&
  first.productCurriculumId === second.productCurriculumId;

const apply = (existingUpdates: LicenseUpdate[], update: LicenseUpdate) => {
  const existing = existingUpdates.find(isSameStudentCurriculum(update));

  if (existing && existing.action !== update.action) {
    return existingUpdates.filter(negate(isSameStudentCurriculum(existing)));
  }

  const updates = existingUpdates.filter(
    u =>
      u.productFamilyId !== update.productFamilyId ||
      u.studentId !== update.studentId ||
      u.action !== update.action
  );

  return [...updates, update];
};

const reducer: Reducer<LicenseUpdate[], Action> = (
  state: LicenseUpdate[],
  { type, payload }: Action
) => {
  switch (type) {
    case ActionType.ADD_UPDATE: {
      return apply(state, payload);
    }
    default: {
      return state;
    }
  }
};

export default reducer;
